import { type HardwareMicButtonPressedPayload } from '@/tauri/dictation/api';
import {
  deviceButtonMappingsAtom,
  dictateMapFunctionalityDialogRequestAtom,
} from '@heidi/dictate/data';
import { getDefaultStore } from 'jotai';

import { handleInsertSnippet } from './insert-snippet';

const INSERT_SNIPPET = 'insert_snippet';

const resolvedAction = (
  payload: HardwareMicButtonPressedPayload
): HardwareMicButtonPressedPayload['action'] =>
  getDefaultStore().get(deviceButtonMappingsAtom)[payload.deviceKey]?.[
    payload.buttonId
  ] ?? payload.action;

export const handleInsertSnippetPress = (
  payload: HardwareMicButtonPressedPayload
): void => {
  if (getDefaultStore().get(dictateMapFunctionalityDialogRequestAtom) !== null) {
    return;
  }
  const action = resolvedAction(payload);
  if (action?.type !== INSERT_SNIPPET || !action.snippetId) {
    return;
  }
  void handleInsertSnippet(action.snippetId);
};
